import { render, staticRenderFns } from "./AccountReportTemplateForm.vue?vue&type=template&id=061b72fc&scoped=true"
import script from "./AccountReportTemplateForm.vue?vue&type=script&lang=js"
export * from "./AccountReportTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061b72fc",
  null
  
)

export default component.exports